import React from "react";
import { Link, useNavigate } from "react-router-dom";

import { Slider } from './Slider.js';

import '../css/SingleImage.css';

export const SingleImage = (props) => {
  const navigate = useNavigate();

  if (!props.getJpegs.length) props.refreshJpegs()    // If you arrived here from a link props.getJpegs will be blank so call refresh()

  
  let jpegsArray = props.getJpegs;                                              // jpegsArray to point to the Redux store jpegs
  if (props.selectedPage === 'basket') jpegsArray = props.getBasket             // If you arrived here from the basket jpegsArray will be the basket

  const urlFilename = () => {                                                   // Get filename from URL:
    let pathNames = window.location.pathname.split('/')                         // Split path at '/' and make all segments into an array
    return decodeURIComponent(pathNames[pathNames.length - 1]);                 // Return the last in the array (will be the file name) and
  }                                                                             // Parse it for escape chars

  const currentJpegItem = {                                                     // Set up the currentJpegItem pointer
    jpegItem: jpegsArray.find( item => item?.file === urlFilename()),            // Retrieves the filename for the current item from the URL
    index: jpegsArray.findIndex( item => item?.file === urlFilename())           // Looks up the index for the current item
  }

  const prev = { ...currentJpegItem }                                           // Set up the previous item pointer for the prev button
	if (currentJpegItem.index > 0) {                                              // If not the first item in the array
		prev.jpegItem = jpegsArray[currentJpegItem.index - 1];                      // Target the previous item in the array
		prev.index --;                                                              // Set the index
	}

  const next = { ...currentJpegItem }                                           // Set up the next item pointer for the next button
	if (currentJpegItem.index < jpegsArray.length - 1) {                          // If not the last item in the array
		next.jpegItem = jpegsArray[currentJpegItem.index + 1];                      // Target the next item in the array
		next.index ++;                                                              // Set the index
	}

  /*                                                                          **
  ** This next section establishes an event listener on the document object   **
  ** listening for the "onkeydown" event. It specifically reacts to three     **
  ** buttons: left arrow, right arrow and escape used to navigate left, right **
  ** and exit.                                                                **
  **                                                                          */

  const nextFunc = () => {                                                      // Switch to next image
    if (currentJpegItem.index < jpegsArray.length - 1)                          // if not last image
      navigate('/single/' + next.jpegItem?.file)                                       // Push new URL to history hook
  }

  const prevFunc = () => {                                                      // Switch to prev image
    if (currentJpegItem.index > 0)                                              // if not first image
      navigate('/single/' + prev.jpegItem?.file)                                       // Push new URL to history hook
  }

  const exitFunc = () => {                                                      // Exit single view
    navigate(                                                                   // push to history hook
      props.selectedPage === 'gallery'                                          // if selectedPage in not either
      || props.selectedPage ==='basket'                                         // 'gallery' or 'basket' default
      ? '/' + props.selectedPage                                                // to 'gallery' otherwise append
      : '/gallery'                                                              // selectedPage to URL
    )
    document.onkeydown = null                                                   // on exit disable eventListener
  }

  document.onkeydown = event => {                                                // Attach listener to the document object
    // console.log('key pressed!!! KeyCode: ', event.keyCode);
    // console.log('History: ', history);
    if (event.keyCode === 39) nextFunc();       // 39 = right arrow
    if (event.keyCode === 37) prevFunc();       // 37 = left arrow
    if (event.keyCode === 27) exitFunc();       // 27 = escape
    event.preventDefault();                     // prevent the default action for the pressed keys (window scrolling)
  }

// exitButton() - A simple React link to either the gallery or the basket depending on which one is selected
  const exitButton = () => {
    return(<Link className="exit-button top-buttons" to={ '/' + props.selectedPage } />)
  }

// nextButton() - links to the next pointer object defined earlier
// Return is conditional/ternary – if it's the last image in the array return dysfunctional button
	const nextButton = () => {
		return ( (currentJpegItem.index < jpegsArray.length - 1) ?
			<Link
				className="next-image next-prev-button"
				to={`/single/${next.jpegItem?.file}`}
			/> :
      <div className="next-image no-highlight next-prev-button" />
		)
	}

// prevButton() - links to the previous pointer object
// Return is conditional/ternary - if it's the first in the array return dysfunctional button
	const prevButton = () => {
		return( (currentJpegItem.index > 0) ?
			<Link
				className="prev-image disable-selection next-prev-button"
				to={`/single/${prev.jpegItem?.file}`}
			/> :
      <div className="prev-image no-highlight next-prev-button" />
		)
	}

// addRemoveButtonDispenser() – chooses which of the four remove button variants to use or returns addButton()
  const addRemoveButtonDispenser = (currentItem) => {

    // removeGallery() - if viewing the gallery remove button will just
    // remove image from basket
    const removeGallery = (currentItem) => {
      return(
        <button
          className="top-buttons remove-button"
  				onClick={() => {
            props.toggleIsFetching(true);
            props.removeBasket(props.getBasket.findIndex(item => item.id === currentItem.jpegItem.id))
            props.toggleIsFetching(false);
          }}
        />
      );
    }

    // lastInBasket() - If last image in basket link back to
    // basket view after image is removed
    const removeLastInBasket = (currentItem) => {
      return(<Link
        className="top-buttons remove-button"
        to={ '/basket' }
        onClick={() => {
          props.toggleIsFetching(true);
          props.removeBasket(currentItem.index)
          props.toggleIsFetching(false);
        }}
      />);
    }

    // If at the beginning of the basket slide to next after image is removed
    const removeBeginningOfBasket = (currentItem) => {
      return(!props.isFetching ?
        <Link
          className="top-buttons remove-button"
          to={ '/single/' + next.jpegItem?.file }
          onClick={async () => {
            props.toggleIsFetching(true);
            props.removeBasket(currentItem.index);
            props.toggleIsFetching(false);
          }}
        /> :
        <div className="top-buttons add-button"  />
      );
    }

    // If in the middle of the basket array slide to previous after image is removed
    const removeFromBasket = (currentItem) => {
      return(<Link
        className="top-buttons remove-button"
        to={ '/single/' + prev.jpegItem?.file }
        onClick={() => {
          props.toggleIsFetching(true);
          props.removeBasket(currentItem.index)
          props.toggleIsFetching(false);
        }}
      />);
    }

    // addButton() - calls the addBasket() Redux action and passes in the current image
  	const addButton = (currentItem) => {
  		return(
  			<button
  				className="add-button top-buttons"
  				onClick={ () => props.addBasket(currentItem.jpegItem) }
  			/>
  		)
  	}

    if (
      props.getBasket.length === 0
      || !props.getBasket.some(item => item?.file === currentItem.jpegItem?.file) // If the basket is empty or the current item is not in the basket
    ) return addButton(currentItem)                                             // Return addButton() button
    else if (props.selectedPage === 'gallery')                                  // If we are viewing the gallery images
      return removeGallery(currentItem)                                         // Return removeGallery() button
    else if (props.getBasket.length <= 1)                                       // If we are viewing the only item in the basket
      return removeLastInBasket(currentItem)                                    // Return removeLastInBasket() button
    else if (currentItem.index === 0)                                           // If we are viewing the first item in the basket
      return removeBeginningOfBasket(currentItem)                               // Return removeBeginningOfBasket() button
    else return removeFromBasket(currentItem)                                   // Otherwise we're in the middle of the basket
  }

// This is a conditional return statement – it will wait for jpegsArray to be
// refreshed before it tries to render anything. Otherwise, if you arrive here
// from a link, jpegsArray will be empty and the refresh method will be
// triggered after the component is rendered, causing a crash!
	return(
		<div className="single-wrapper">
				<Link
					to={ '/images/' + currentJpegItem.jpegItem?.file }
					target='_blank'
				>
					{ Slider(currentJpegItem.index, jpegsArray, props) }
        </Link>
        <div className="top-buttons-container">
          { exitButton() }
          { addRemoveButtonDispenser(currentJpegItem) }
        </div>
        <div className="next-prev-container">
          { prevButton() }
          { nextButton() }
        </div>
		</div>
	)
}
